import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var SignOutRes;
export const SignOutTodo = createAsyncThunk('SignOut', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/user_logout',
            data: {
                "user_code": user_id.vemp_code,
                "user_role": user_id.vrole_name,
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return SignOutRes = res.data
    } catch (error) {
        return SignOutRes = error.response.data
    }
})